export const ossConstants = {
    GET_YEARLY_SALES_OVERVIEW_REQUEST: "GET_YEARLY_SALES_OVERVIEW_REQUEST",
    GET_YEARLY_SALES_OVERVIEW_SUCCESS: "GET_YEARLY_SALES_OVERVIEW_SUCCESS",
    GET_YEARLY_SALES_OVERVIEW_FAILURE: "GET_YEARLY_SALES_OVERVIEW_FAILURE",

    PERFORM_TAX_CHECK_REQUEST: "PERFORM_TAX_CHECK_REQUEST",
    PERFORM_TAX_CHECK_SUCCESS: "PERFORM_TAX_CHECK_SUCCESS",
    PERFORM_TAX_CHECK_FAILURE: "PERFORM_TAX_CHECK_FAILURE",

    REFRESH_OSS_DASHBOARD_REQUEST: "REFRESH_OSS_DASHBOARD_REQUEST",
    REFRESH_OSS_DASHBOARD_SUCCESS: "REFRESH_OSS_DASHBOARD_SUCCESS",
    REFRESH_OSS_DASHBOARD_FAILURE: "REFRESH_OSS_DASHBOARD_FAILURE",

    POLL_YEARLY_SALES_OVERVIEW_SUCCESS: "POLL_YEARLY_SALES_OVERVIEW_SUCCESS",
};

